// extracted by mini-css-extract-plugin
export const row = "FeaturedContentRow-module--row--2_BDb";
export const buttons = "FeaturedContentRow-module--buttons--3SLgu";
export const withRegularImage = "FeaturedContentRow-module--with-regular-image--11oKV";
export const withSmallImage = "FeaturedContentRow-module--with-small-image--25Jse";
export const tagline = "FeaturedContentRow-module--tagline--1_sdE";
export const title = "FeaturedContentRow-module--title--2lbR5";
export const content = "FeaturedContentRow-module--content--2wqUk";
export const description = "FeaturedContentRow-module--description--11vLC";
export const images = "FeaturedContentRow-module--images--3pjbK";